import React from 'react';
import { Link } from 'react-router-dom';
import useGearCatalog from './gear/useGearCatalog';
import { GearImage } from './gear/GearCatalogPage';
import { filterGearCatalog, formatGearPrice, gearPath } from '../domain/gearCatalog';
import OfferSavingsBadge from './PriceComparison/OfferSavingsBadge';
import AmazonPriceNotice from './PriceComparison/AmazonPriceNotice';
import './HomeDealsPreview.css';

export default function HomeDealsPreview() {
  const { products, loading } = useGearCatalog();
  const picks = filterGearCatalog(products.filter(p=>p.hasBuyingOptions && p.image
    && p.imageKind!=='coverage-preview' && p.releaseState!=='watchlist'),{sort:'deals'}).slice(0,3);
  const hasDeals = !loading && picks.some(p=>p.bestPrice!=null && p.savings?.amount>0);
  return <div className="ab-home-deal-visual">
    <section className="ab-home-preview" aria-labelledby="home-preview-title">
      <div className="ab-home-preview-header">
        <div><p>THE ANGLER BUILT PRICE FINDER</p><h2 id="home-preview-title">{hasDeals?'Good gear. Better prices.':'Your next find starts here.'}</h2></div>
        <span className="ab-home-preview-stamp">{hasDeals?'Current deals':'Compare & save'}</span>
      </div>
      <div className="ab-home-preview-products" aria-busy={loading}>
        {picks.map(product=><Link className="ab-home-preview-product" to={gearPath(product)} key={product.id} title={`See retailer offers for ${product.brand} ${product.name}`}>
          <div className="ab-home-preview-image"><GearImage product={product} eager/></div>
          <div className="ab-home-preview-identity"><p>{product.brand}</p><h3>{product.name}</h3></div>
          <div className="ab-home-preview-quote">
            {!loading && product.bestPrice!=null ? <>
              {product.savings && <s aria-label={`Regular price ${formatGearPrice(product.savings.referencePrice)}`}>{formatGearPrice(product.savings.referencePrice)}</s>}
              <span className="ab-home-preview-price-label">Current lowest price</span>
              <strong>{formatGearPrice(product.bestPrice)}</strong>
              <OfferSavingsBadge savings={product.savings}/>
            </> : <span className="ab-home-preview-pending">{loading?'Checking prices…':'See retailer offers →'}</span>}
          </div>
        </Link>)}
      </div>
      <Link className="ab-home-preview-footer" to="/price-comparison"><span>See the deals. Compare your options.</span><b>Find other deals <span aria-hidden="true">→</span></b></Link>
    </section>
    <div className="ab-home-preview-notice"><AmazonPriceNotice offers={loading?[]:picks.map(p=>p.bestOffer).filter(Boolean)}/></div>
  </div>;
}
